export default "__VITE_ASSET__ZabZJ_cE__"